import { useTranslation } from 'react-i18next';
import { Badge } from '@shared/ui';
import type { KycStatus } from '@entities/session';

const TONE: Record<KycStatus, 'neutral' | 'warning' | 'success' | 'danger'> = {
  NONE: 'neutral',
  PENDING: 'warning',
  VERIFIED: 'success',
  REJECTED: 'danger',
};

export function KycBadge({ status }: { status: KycStatus }) {
  const { t } = useTranslation();
  return <Badge tone={TONE[status]}>{t(`kyc.badge.${status}`)}</Badge>;
}
